import { useState } from "react";
import { useEffect } from "react";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";
import { es } from 'date-fns/locale';
import { addDays, addMonths, addYears, format, isAfter, parse, subDays, subMonths, subYears } from 'date-fns';
import { Button } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ResetIcon from "../../../components/Icons/ResetIcon";
import { useFilterActas } from "../../../store/filterActasStore";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
// import { utcToZonedTime } from 'date-fns-tz';

const ModalFiltroFechas = ({ setFiltros, filtros, showButtonSubmit = true }) => {

    const { fechasReporte, setFechasReporte } = useNotificadoresStore();
    const timeZone = 'UTC';

    // const { setFiltross, filtross } = useFilterActas();

    const { handlerModal } = useGeneralAppStore();
    // Deshabilitar el scroll de fondo cuando el modal está abierto

    const fechaHoy = new Date();
    const fechaUnMesAntes = new Date(fechaHoy);
    fechaUnMesAntes.setMonth(fechaUnMesAntes.getMonth() - 1);
    const fechaHaceUnMes = fechaUnMesAntes;

    const [error, setError] = useState(false);

    // const [fechaDesde, setFechaDesde] = useState(filtros?.fecha_desde ? new Date(filtros.fecha_desde) :null);
    // const [fechaDesde, setFechaDesde] = useState(filtros?.fecha_desde ? new Date(new Date(filtros.fecha_desde).setDate(new Date(filtros.fecha_desde).getDate() + 1)) : fechaHaceUnMes);
    const [fechaDesde, setFechaDesde] = useState(new Date(fechasReporte?.fecha_desde));
    // const [fechaHasta, setFechaHasta] = useState(filtros?.fecha_hasta ? new Date(new Date(filtros.fecha_hasta).setDate(new Date(filtros.fecha_hasta).getDate() + 1)) : fechaHoy);
    const [fechaHasta, setFechaHasta] = useState(new Date(fechasReporte?.fecha_hasta));

    const ajustarFecha = (campo, operacion, setter, fecha) => {
        const operaciones = {
            dia: operacion == "suma" ? addDays : subDays,
            mes: operacion == "suma" ? addMonths : subMonths,
            año: operacion == "suma" ? addYears : subYears,
        }
        return (operaciones[campo](fecha || fechaHoy, 1))
    }


    const handlerFecha = (campo, operacion, current) => {
        if (campo == "dia") {
            if (operacion == "suma") {
                current == "fecha_desde" ? setFechaDesde(addDays(fechaDesde || fechaHoy, 1)) : setFechaHasta(addDays(fechaHasta || fechaHoy, 1))
            }
            else current == "fecha_desde" ? setFechaDesde(subDays(fechaDesde || fechaHoy, 1)) : setFechaHasta(subDays(fechaHasta || fechaHoy, 1))
        }
        if (campo == "mes") {
            if (operacion == "suma") {
                current == "fecha_desde" ? setFechaDesde(addMonths(fechaDesde || fechaHoy, 1)) : setFechaHasta(addMonths(fechaHasta || fechaHoy, 1))
            }
            else current == "fecha_desde" ? setFechaDesde(subMonths(fechaDesde || fechaHoy, 1)) : setFechaHasta(subMonths(fechaHasta || fechaHoy, 1))
        }
        if (campo == "año") {
            if (operacion == "suma") {
                current == "fecha_desde" ? setFechaDesde(addYears(fechaDesde || fechaHoy, 1)) : setFechaHasta(addYears(fechaHasta || fechaHoy, 1))
            }
            else current == "fecha_desde" ? setFechaDesde(subYears(fechaDesde || fechaHoy, 1)) : setFechaHasta(subYears(fechaHasta || fechaHoy, 1))
        }
    };

    const resetFecha = (current) => {
        if (current == "fecha_desde") setFechaDesde(null)
        if (current == "fecha_hasta") setFechaHasta(null)
    }

    const handleSubmit = () => {
        // console.log(fechaHasta)
        // console.log( format(fechaHasta, 'yyyy-MM-dd'))
        // setFiltros({
        //     fecha_desde: fechaDesde ? format(fechaDesde, 'yyyy-MM-dd'): null,
        //     fecha_hasta: fechaHasta ? format(fechaHasta, 'yyyy-MM-dd') : null,
        // });
        // setFiltros({
        //     fecha_desde: fechaDesde ? format(fechaDesde, 'yyyy-MM-dd') : null,
        //     fecha_hasta: fechaHasta ? format(fechaHasta, 'yyyy-MM-dd') : null,
        // });
        setFechasReporte((fechaDesde ?? null), (fechaHasta ?? null))
        // { fechaDesde ? setFiltros("fecha_desde", format(fechaDesde, 'yyyy-MM-dd')) : setFiltros("fecha_desde", null); }
        // { fechaHasta ? setFiltros("fecha_hasta", format(fechaHasta, 'yyyy-MM-dd')) : setFiltros("fecha_hasta", null); }

        // { fechaHasta && setFiltros("fecha_hasta", format(fechaHasta, 'yyyy-MM-dd')); }
        // { fechaHasta && setFiltros("fecha_hasta", format(fechaHasta, 'yyyy-MM-dd')); }

        // setFiltros("fecha_desde", fechaDesde);
        // setFiltersField((prevState) => ({
        //     ...prevState,
        //     ["fecha_desde"]: fechaDesde 
        // }));
        // setFiltersField((prevState) => ({
        //     ...prevState,
        //     ["fecha_hasta"]: fechaHasta 
        // }));

        handlerModal({ modal: false, modalName: "rango_fecha" })
    }


    useEffect(() => {
        if (fechaHasta != null && fechaDesde != null) {
            if (isAfter(fechaDesde, fechaHasta)) {
                setError(true)
            } else {
                setError(false)
            }
        }

        document.body.style.overflow = 'hidden';  // Deshabilita el scroll del body
        return () => {
            document.body.style.overflow = 'auto';  // Lo habilita de nuevo al desmontar
        };
    }, [fechaHasta, fechaDesde]);




    return (
        <section className="   top-0 position-fixed z-3 " style={{ backgroundColor: "rgba(1,1,1,0.7)", zIndex: "10", width: "100%", height: "100%", left: "0" }}>
            <div className=" d-flex justify-content-center align-items-center h-100">

                <div className="bg-white rounded  row col-12 col-sm-10 col-md-8 col-lg-6  pb-2 position-relative" >
                    <IconButton
                        onClick={() => { handlerModal({ modal: false, modalName: "rango_fecha" }) }}
                        className="position-absolute text-white" style={{ top: "10px", right: "10px", width: "fit-content" }}>
                        <CloseIcon />

                    </IconButton>
                    <h3 className="text-center m-0 py-3 text-white" style={{ backgroundColor: "#1134C9" }}>Filtrar fechas</h3>
                    <hr className="mb-1" />
                    <div className="col-5 d-flex flex-column align-items-center " >
                        <div className="d-flex gap-2 align-items-center">
                            <h5 className="m-0">Fecha desde</h5>
                            <IconButton onClick={() => resetFecha('fecha_desde')}>
                                <ResetIcon width={20} />
                            </IconButton>
                        </div>
                        <i className={`fw-light mb-2 ${error && 'text-danger'}`} style={{ height: !fechaDesde && "24px" }}>{fechaDesde && format(fechaDesde, 'PPPP', { locale: es })}  </i>

                        <div className="d-flex justify-content-center  position-relative" style={{ gap: "2rem" }} >
                            {/* <Button onClick={() => { resetFecha("fecha_desde") }} size="sm" className="position-absolute " style={{ bottom: "4%", left: "50%", transform: "translateX(-50%)" }}>Resetear</Button> */}
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p className="m-0 fw-bold">DÍA</p>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
                                    <IconButton
                                        onClick={() => handlerFecha("dia", "suma", "fecha_desde")}
                                    //  onClick={() => ajustarFecha("dia", "suma", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowUpIcon color="primary" />
                                    </IconButton>
                                    <span className="text-primary fw-bold fs-5">{fechaDesde?.getDate() || " -- "}</span>
                                    <IconButton
                                        onClick={() => handlerFecha("dia", "resta", "fecha_desde")}
                                    // onClick={() => ajustarFecha("dia", "resta", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowDownIcon color="primary" />
                                    </IconButton>
                                </div>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p className="m-0 fw-bold">MES</p>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
                                    <IconButton
                                        onClick={() => handlerFecha("mes", "suma", "fecha_desde")}
                                    // onClick={() => ajustarFecha("mes", "suma", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowUpIcon color="primary" />
                                    </IconButton>
                                    <span className="text-primary fw-bold fs-5">{fechaDesde?.getMonth() + 1 || " -- "}</span>
                                    <IconButton
                                        onClick={() => handlerFecha("mes", "resta", "fecha_desde")}
                                    // onClick={() => ajustarFecha("mes", "resta", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowDownIcon color="primary" />
                                    </IconButton>
                                </div>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p className="m-0 fw-bold">AÑO</p>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
                                    <IconButton
                                        onClick={() => handlerFecha("año", "suma", "fecha_desde")}
                                    //  onClick={() => ajustarFecha("año", "suma", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowUpIcon color="primary" />
                                    </IconButton>
                                    <span className="text-primary fw-bold fs-5" >{fechaDesde?.getFullYear() || " -- "}</span>
                                    <IconButton
                                        onClick={() => handlerFecha("año", "resta", "fecha_desde")}
                                    // onClick={() => ajustarFecha("año", "resta", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowDownIcon color="primary" />
                                    </IconButton>
                                </div>
                            </div>
                        </div>



                    </div>
                    <div className="col-2 d-flex flex-column gap-2 align-items-center justify-content-center" style={{ cursor: "pointer" }}
                        onClick={() => {
                            setFechaDesde(fechaHaceUnMes)
                            setFechaHasta(fechaHoy)
                        }}
                    >
                        <ResetIcon width={60} color={"#1134C9"} />
                        <p className="mb-0 fw-bold" style={{ fontSize: "14px", color: "#1134C9" }}>Reiniciar</p>
                    </div>
                    <div className="col-5 d-flex flex-column align-items-center " >
                        <div className="d-flex gap-2 align-items-center">
                            <h5 className="m-0">Fecha hasta</h5>
                            <IconButton onClick={() => resetFecha('fecha_hasta')}>
                                <ResetIcon width={20} />
                            </IconButton>
                        </div>
                        <i className={`fw-light mb-2 ${error && 'text-danger'}`} style={{ height: !fechaHasta && "24px" }}>{fechaHasta && format(fechaHasta, 'PPPP', { locale: es })}</i>
                        <div className="d-flex justify-content-center  position-relative" style={{ gap: "2rem" }} >
                            {/* <Button onClick={() => { resetFecha("fecha_hasta") }} size="sm" className="position-absolute " style={{ bottom: "4%", left: "50%", transform: "translateX(-50%)" }}>Resetear</Button> */}
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p className="m-0 fw-bold">DÍA</p>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
                                    <IconButton
                                        onClick={() => handlerFecha("dia", "suma")}
                                    // onClick={() => ajustarFecha("dia", "suma", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowUpIcon color="primary" />
                                    </IconButton>
                                    <span className="text-primary fw-bold fs-5">{fechaHasta?.getDate() || " -- "}</span>
                                    <IconButton
                                        onClick={() => handlerFecha("dia", "resta")}
                                    // onClick={() => ajustarFecha("dia", "resta", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowDownIcon color="primary" />
                                    </IconButton>
                                </div>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p className="m-0 fw-bold">MES</p>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
                                    <IconButton
                                        onClick={() => handlerFecha("mes", "suma")}
                                    // onClick={() => ajustarFecha("mes", "suma", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowUpIcon color="primary" />
                                    </IconButton>
                                    <span className="text-primary fw-bold fs-5">{fechaHasta?.getMonth() + 1 || " -- "}</span>
                                    <IconButton
                                        onClick={() => handlerFecha("mes", "resta")}
                                    // onClick={() => ajustarFecha("mes", "resta", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowDownIcon color="primary" />
                                    </IconButton>
                                </div>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p className="m-0 fw-bold">AÑO</p>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
                                    <IconButton
                                        onClick={() => handlerFecha("año", "suma")}
                                    // onClick={() => ajustarFecha("año", "suma", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowUpIcon color="primary" />
                                    </IconButton>
                                    <span className="text-primary fw-bold fs-5">{fechaHasta?.getFullYear() || " -- "}</span>
                                    <IconButton
                                        onClick={() => handlerFecha("año", "resta")}
                                    // onClick={() => ajustarFecha("año", "resta", setFechaDesde, fechaDesde)}
                                    >
                                        <KeyboardArrowDownIcon color="primary" />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-3  align-items-center pb-3 ">
                        {/* <div className="d-flex gap-2 ">
                            <p className={`m-0 fw-bold ${error && "text-danger"}`}> {fechaDesde ? format(fechaDesde, 'yyyy-MM-dd') : " Hasta "}</p>
                            <p className={`m-0 fw-bold ${error && "text-danger"}`}>{fechaHasta ? format(fechaHasta, 'yyyy-MM-dd') : " Desde "}</p>
                        </div> */}
                        <div style={{ height: "20px" }} className="text-danger fw-medium " >{error && "Error de fechas"}</div>
                        <Button disabled={error} size="sm" onClick={() => { handleSubmit() }}>{showButtonSubmit ? 'Filtrar fechas' : 'Confirmar fechas'}</Button>
                    </div>

                </div>

            </div>
        </section>
    )
}

export default ModalFiltroFechas;
